import React from 'react';
import styles from "./Spinner.module.css"

const Spinner = (props) => {
    return (
        <div className={styles.Loader}>
            
        </div>
    )
}

export default Spinner;
